import { FiImage, FiFilm, FiVideo, FiHeadphones } from 'react-icons/fi';

// Opt-in features switched on per user in User Management. Mirrors
// backend/src/config/features.js — the backend is what actually enforces
// access; this list drives the sidebar, the route gate and the admin UI.
// alwaysOnRoles have the feature regardless of the switch.
export const FEATURES = [
  { key: 'mediaAI', field: 'mediaAIEnabled', icon: FiImage, labelKey: 'features.mediaAI', descKey: 'features.mediaAIDesc', alwaysOnRoles: ['admin', 'superadmin'] },
  { key: 'fullStory', field: 'fullStoryEnabled', icon: FiFilm, labelKey: 'features.fullStory', descKey: 'features.fullStoryDesc', alwaysOnRoles: ['admin', 'superadmin', 'manager'] },
  { key: 'fullStoryVideo', field: 'fullStoryVideoEnabled', icon: FiVideo, labelKey: 'features.fullStoryVideo', descKey: 'features.fullStoryVideoDesc', alwaysOnRoles: ['admin', 'superadmin', 'manager'] },
  // onWhenUnset: accounts from before the switch existed keep their access (see backend config/features.js).
  { key: 'scriptToVoice', field: 'scriptToVoiceEnabled', icon: FiHeadphones, labelKey: 'features.scriptToVoice', descKey: 'features.scriptToVoiceDesc', alwaysOnRoles: ['admin', 'superadmin', 'manager'], onWhenUnset: true },
];

/** The user's own switch for `feature` (an account from before an onWhenUnset switch existed counts as on). */
const isOn = (feature, user) => user?.[feature.field] === true || (feature.onWhenUnset === true && user?.[feature.field] == null);

/** True when `role` has `feature` (an entry of FEATURES) without needing the switch. */
export const isAlwaysOn = (feature, role) => feature.alwaysOnRoles.includes(role);

export const hasFeature = (user, key) => {
  const feature = FEATURES.find((f) => f.key === key);
  if (!user || !feature) return false;
  return isAlwaysOn(feature, user.role) || isOn(feature, user);
};

/** { mediaAI: true, fullStory: false } from a user's stored flags — the shape the create/edit endpoints take. */
export const featureMap = (user) =>
  Object.fromEntries(FEATURES.map((f) => [f.key, Boolean(user) && isOn(f, user)]));
